import { InjectionToken } from '@angular/core';

export interface PopoutData {
  modalName: string;
  AppKey: number;
  CompanyKey: number;
}

export const POPOUT_MODAL_DATA = new InjectionToken<PopoutData>('POPOUT_MODAL_DATA');

export enum PopoutModalName {
  'ReportComponent' = 'Reports'
}

export let POPOUT_MODALS = {
};